export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/test-drive-icon.3759c3d5.svg","height":56,"width":56,"blurWidth":0,"blurHeight":0};